import React, { Component } from 'react'
import axios from 'axios'
import { sn_url } from '../../utils/js/endpoints'
import { setLocalStorage, getLocalStorage } from '../../utils/js/browser_helpers'
import { dispatchAnalytics } from '../../utils/js/analytic_helpers'
import { handleError } from 'utils/js/error_helpers'

import './CalReply.scss'

class CalReply extends Component {
    constructor(props) {
        super(props)

        this.source = null
        this.mounted = false
        this.cachekey = `${props.league}_${props.type}_calreply`

        this.state = {
            loading: true,
            league: props.league,
            type: props.type,
            html: '',
        }
    }

    componentDidMount() {
        this.mounted = true
        const { league, type } = this.state

        getLocalStorage(this.cachekey, res => {
            if (res.success) {
                this.setState({
                    html: res.data,
                    isFetching: false,
                    isError: false,
                })
            } else {
                this.getCalReply(league, type)
            }
        })
    }

    componentWillUnmount() {
        this.mounted = false
        if (this.source) this.source.cancel()
    }

    getCalReply(league, type) {
        this.source = axios.CancelToken.source()

        axios
            .get(`${sn_url}/wp-json/snapi/v0.1/calreply/?league=${league}&type=${type}`, {
                cancelToken: this.source.token,
            })
            .then(response => {
                if (this.mounted) {
                    this.setState(
                        {
                            html: response.data.html,
                            isFetching: false,
                            isError: false,
                        },
                        () => {
                            setLocalStorage(this.cachekey, response.data.html)
                        }
                    )
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    this.setState({
                        html: '',
                        isFetching: false,
                        isError: true,
                    })
                }
                handleError(error)
            })
    }

    render() {
        const html = this.state.html

        return (
            <div
                className="CalReply"
                dangerouslySetInnerHTML={{ __html: html }}
                onClick={() => {
                    dispatchAnalytics({
                        type: 'DTM_TRACK_ADD_TO_SCHEDULE',
                        origin: 'button',
                    })
                }}
                tabIndex={0}
            />
        )
    }
}

export default CalReply
